export default __webpack_public_path__ + "static/media/IBEW-fornax-banner-img.fbda8bfb.png";